import { PollVote, PollWidget } from 'open-modules/cbcrc/feature/poll/pollwidget';
import { STATIC_TOPIC } from 'open-modules/cbcrc/feature/admin/static';
import { demoFile, componentWithVariants, variant, story, CLICK } from 'system/demo';
import { declareTable, t } from 'util/stdtypes';

demoFile('open-modules/cbcrc/feature/poll/pollwidget');

// const options = STATIC_TOPIC.poll.options.map(o => '!' + o.label);

const pollKey = declareTable<PollVote>('topicPoll');
const baseArgs = {
    pollKey,
    question: STATIC_TOPIC.poll.question,
    optionLabels: STATIC_TOPIC.poll.options.map(o => t('!' + o.label)),
    // optionTexts: STATIC_TOPIC.poll.options,
    showOtherOption: false,
    otherOptionLabel: t('!Other'),
    otherOptionText: '!Other',
    otherOptionPlaceholder: undefined
};

componentWithVariants('PollWidget', PollWidget, { args: baseArgs, state: { collections: { topicPoll: [] }, modulePublic: { language: 'english' } } }, [
    variant('Logged in', { state: { modulePublic: { language: 'english' } } }, [
        story('Neutral', [CLICK('!Neutral'), CLICK('Submit my vote')]),
        story('Neutral then Somewhat negative', [
            CLICK('!Neutral'),
            CLICK('Submit my vote'),
            CLICK('Change my vote'),
            CLICK('!Somewhat negative'),
            CLICK('Submit my vote')
        ])
    ]),
    variant('Logged out', { state: { personaKey: null, modulePublic: { language: 'english' } } }, [
        story('Neutral', [CLICK('!Neutral'), CLICK('Submit my vote')])
    ])
]);
